export const DefaultChannel = {
    id: 0,
    title: '平台渠道',
};

// 会议执行类型
export const conferenceTypes = [
    { label: '线上', type: 1 },
    { label: '线下', type: 2 },
    { label: '线上+线下', type: 3 },
];

export const HotelList = [
    {
        key: '琼海博鳌亚洲论坛大酒店',
        label: '琼海博鳌亚洲论坛大酒店',
        address: '琼海博鳌东屿岛远洋大道1号',
        roomTypes: ['高级大床房', '高级双床房', '豪华大床房', '豪华双床房', '海景大床房', '海景双床房', '豪华海景大床房', '豪华海景双床房', '行政大床房', '行政双床房'],
    },
    {
        key: '琼海博鳌亚洲论坛东屿岛大酒店',
        label: '琼海博鳌亚洲论坛东屿岛大酒店',
        address: '琼海博鳌东屿岛远洋大道2号',
        roomTypes: ['园景大床房', '园景双床房', '河景大床房', '河景双床房', '海景大床房', '海景双床房', '豪华海景双床房'],
    },
    {
        key: '琼海博鳌亚洲论坛金海岸大酒店',
        label: '琼海博鳌亚洲论坛金海岸大酒店',
        address: '海南省琼海市博鳌金海岸大道8号',
        roomTypes: ['大床房', '双床房', '套房', '标间'],
    },
];
